import { buildProps, definePropType } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type SortSelector from './sort-selector.vue'

interface SortSelectorItem {
  label: any
  value: any
  orderBy: string
}

export const sortSelectorProps = buildProps({
  options: {
    type: definePropType<SortSelectorItem[]>(Array),
    default: () => [],
  },
  selectValue: {
    type: String,
  },
  sortValue: {
    type: String,
  },
  // 尺寸
  size: {
    type: String as () => SizeType,
  },

  // 下拉框最小宽
  minWidth: {
    type: Number || String,
    default: 120,
  },
  // 下拉框最大宽
  maxWidth: {
    type: Number || String,
  },
  // 升序文本
  ascText: {
    type: String,
  },
  // 降序文本
  descText: {
    type: String,
  },
  fieldNames: {
    type: Object,
    default: () => ({
      label: 'label',
      value: 'value',
    }),
  },
} as const)

// props
export type SortSelectorProps = ExtractPropTypes<typeof sortSelectorProps>

// instance
export type SortSelectorInstance = InstanceType<typeof SortSelector>
